import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Select } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Select/Form.tsx
var SelectFieldForm = ({ config }) => {
	const { errorsByFieldId, fieldValueChanged, valuesByFieldId } = useFormBuilderFieldsContext();
	return /* @__PURE__ */ jsx(Select, {
		allowCreate: config.options.allowCustomTags,
		error: errorsByFieldId[config.id],
		hint: /* @__PURE__ */ jsxs(Fragment$1, { children: [config.options.required && /* @__PURE__ */ jsx("span", {
			className: "text-color-critical text-sm font-light",
			children: "Required"
		}), config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})] }),
		isClearable: true,
		multi: !!config.options.multi,
		label: /* @__PURE__ */ jsx(Fragment$1, { children: config.options.label || config.options.formLabel }),
		onChangeValue: (val) => {
			fieldValueChanged(config.id, val);
		},
		options: config.options?.options?.map(({ label }) => ({
			label,
			value: label
		})) || [],
		subText: config.options.subText,
		value: valuesByFieldId[config.id],
		name: config.name
	});
};
//#endregion
export { SelectFieldForm };

//# sourceMappingURL=Form.js.map